// removed by extract-text-webpack-plugin
module.exports = {"widget":"abLhMTmLIXPGkVIGZ9_Go","title":"_2WrlW0KTLcME7QRbyHzTcB","content":"aZlgTRGuQxeHm8U1Ea9rs","chart":"_28YvQkiLm96cJtQIDbcX8P"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets.new/BoxMissPickChart/widget.scss
// module id = 1267
// module chunks = 0